import React from 'react'
import ReactLoading from 'react-loading'

const Loader = (type, color, width, height) => {
    return <div style={{textAlign: 'center', width: '40%', marginLeft: '30%'}}><ReactLoading width='100%' type='spokes' color='rgb(180,180,180)' /></div>
}

export default Loader